// Region names from the analyze pipeline carry a season suffix ("Northeast -
// Cool Season"). On result surfaces that already state the season ("Cool-season
// grass, common across the...") the suffix reads as a duplicate, so strip it
// for display. Data/plan lookups keep using the raw region string.
export function regionDisplayName(region: string | undefined | null): string {
  if (!region) return ""
  return region.replace(/\s*[-–]\s*(cool|warm)\s+season\s*$/i, "")
}
